import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'mzic-header',
  standalone: true,
  imports: [CommonModule, MatToolbarModule],
  templateUrl: './mzic-header.component.html',
  styleUrls: ['./mzic-header.component.scss'],
})
export class MzicHeaderComponent {

  @Input() title!: string
}
